module.exports = __webpack_public_path__ + "img/message-bg.b76f964c.png";